const isNodeEnvironment = () => {
    // eslint-disable-next-line
    return typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
};

export { isNodeEnvironment as i };
